import { P, FF } from "../../styles/tokens";
import Card from "./Card";

/**
 * EmptyState — componente reutilizable para vistas sin datos.
 * Props:
 *   icon    {string}   — emoji grande central
 *   title   {string}   — título principal
 *   desc    {string}   — descripción secundaria
 *   btnLabel{string}   — texto del botón (opcional)
 *   onBtn   {function} — handler del botón (opcional)
 *   token   {object}   — token de color para el fondo (default P.ingresos)
 */
export default function EmptyState({ icon, title, desc, btnLabel, onBtn, token }) {
  const tok = token || P.ingresos;
  return (
    <Card style={{ background: tok.pastel, border: `1.5px solid ${tok.tint}` }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", padding: "28px 16px" }}>
        <div style={{ fontSize: 48, marginBottom: 14, lineHeight: 1 }}>{icon}</div>
        <div style={{ fontSize: 15, fontWeight: 800, color: P.text, fontFamily: FF, marginBottom: 8 }}>{title}</div>
        <div style={{ fontSize: 13, color: P.textMd, fontFamily: FF, lineHeight: 1.6, marginBottom: btnLabel ? 20 : 0, maxWidth: 280 }}>
          {desc}
        </div>
        {btnLabel && onBtn && (
          <button
            type="button"
            onClick={onBtn}
            style={{
              padding: "11px 28px",
              borderRadius: 12,
              border: "none",
              background: tok.base,
              color: "#fff",
              fontFamily: FF,
              fontSize: 13,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            {btnLabel}
          </button>
        )}
      </div>
    </Card>
  );
}
